import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep';

import FloatingLayerPublic from './FloatingLayerPublic';

import ActionLink from '../builder/ActionLink';
import CurrentUsers from '../users/CurrentUsers';

const ViewCurrentUsers = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ display_current_users, setDisplayCurrentUsers ] = useState(false);

	const promotion = props?.promotion?.Promotion ?? false;
	if(promotion === false) return null;

	return (
		<div class="gui_participants_display">
			[<ActionLink onClick={() => setDisplayCurrentUsers(true)}>View</ActionLink>]

			{(display_current_users) && (
				<FloatingLayerPublic
					pm={promotion}
					title={`<h1>${i18n("Participants")}</h1>`}
					backButton={() => setDisplayCurrentUsers(false)}
				>
					<CurrentUsers
						promotion={promotion}
						limit_entries="100"
						ranking={false}
					/>
				</FloatingLayerPublic>
			)}
		</div>
	)
}

export default injectIntl(ViewCurrentUsers);